import { ExistingAccountActionTypes } from './action-types';
export const initialExistingAccountsState = {
  accounts: [],
  fetchError: false,
  requested: false,
  fetched: false
};

const existingAccountsReducer = (state = initialExistingAccountsState, action) => {
  switch (action.type) {
    case ExistingAccountActionTypes.AccountsRequested:
      return Object.assign({}, state, {
        requested: true
      });

    case ExistingAccountActionTypes.AccountsFetched:
      return Object.assign({}, state, {
        accounts: action.payload,
        fetchError: false,
        fetched: true
      });

    case ExistingAccountActionTypes.AccountsFetchedFailed:
      return Object.assign({}, state, {
        fetchError: true,
        fetched: true
      });

    default:
      return state;
  }
};

export default existingAccountsReducer;